import { Link } from 'react-router-dom'
import { PageSeo } from '@/components/SEOHead'
import { resolveSeo, STATIC_PAGE_SEO } from '@/lib/seo'
import { Container } from '@/components/layout/Container'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <>
      <PageSeo seo={resolveSeo(STATIC_PAGE_SEO.notFound)} />
      <Container className="flex min-h-[60vh] flex-col items-center justify-center py-16 text-center">
        <p className="font-display text-6xl font-extrabold text-primary-500">404</p>
        <h1 className="mt-4 font-display text-2xl font-bold text-neutral-900">Page not found</h1>
        <p className="mt-2 text-neutral-500">The page you're looking for doesn't exist or has moved.</p>
        <Button asChild className="mt-8">
          <Link to="/">Go to Homepage</Link>
        </Button>
      </Container>
    </>
  )
}
